<template>
  <div class="editeventclass eventdata container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <div class="card card-transparent-background mb-0">
            <div class="card-header row pb-0">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-doom-yoga">Edit Event</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <EventPrivateClassInfo action="update"
                  :locations="locations" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventPrivateClassInfo from "./PrivateClassInfo.vue";
import $, { event } from "jquery";
import axios from "axios";
import moment from "moment";

export default {
  name: "EventPrivateClass",
  components: { EventPrivateClassInfo },
  data() {
    return {
      client_name: "DY",

      locations: [
        { text: "ZOOM ONLINE", id: "ZOOM ONLINE" },
        { text: "Kimberley Street, London", id: "Kimberley Street, London" },
        { text: "Dublin, Ireland", id: "Dublin, Ireland" },
        { text: "Studio Doom Yoga, London", id: "Studio Doom Yoga, London" },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style >
.imgFromGroup > div {
  height: calc(100% - 35px);
  max-height: calc(100% - 35px);
}
@media screen and (min-width: 576px) {
  #business-hours-modal .modal-dialog {
    margin-top: 100px;
    max-width: 85%;
    width: 85%;
  }
  .modal-dialog-scrollable {
    height: calc(100% - 10rem);
  }
}
@media screen and (min-width: 768px) {
  #business-hours-modal .modal-dialog {
    max-width: 75%;
    width: 75%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/events/EditEventPrivateClass.vue